import { useState } from "react";

export default function AdGeneratorPage() {
  const [productDescription, setProductDescription] = useState("");
  const [adResult, setAdResult] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const generateAd = async () => {
    const apiUrl = "/functions/v1/quick-worker"; // ה-URL של הפונקציה שלך ב-Supabase

    setLoading(true);
    setAdResult(null);

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ productDescription }),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();
      setAdResult(result);
    } catch (err) {
      console.error("❌ שגיאה במהלך יצירת המודעה:", err);
      alert("נראה שמשהו השתבש. אנא נסה שנית.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 max-w-3xl mx-auto text-right rtl">
      <h1 className="text-3xl font-bold mb-6 text-center">צור מודעת פייסבוק חכמה</h1>

      <textarea
        className="w-full p-3 border border-gray-300 rounded mb-4"
        rows={4}
        placeholder="תאר את המוצר שלך בקצרה..."
        value={productDescription}
        onChange={(e) => setProductDescription(e.target.value)}
      />

      <button
        className="bg-purple-600 text-white py-2 px-6 rounded hover:bg-purple-700 transition"
        onClick={generateAd}
        disabled={loading || !productDescription}
      >
        {loading ? "יוצר מודעה..." : "צור מודעה"}
      </button>

      {adResult && (
        <div className="mt-10">
          <h2 className="text-xl font-bold text-purple-700 mb-4 text-center">
            🔹 תצוגת מודעה
          </h2>

          {/* כותרת המודעה */}
          <div className="bg-white p-4 shadow-md rounded-lg">
            <h3 className="text-lg font-semibold">{adResult.headline}</h3>
            <p className="text-gray-700">{adResult.primary_text}</p>
            <p className="mt-2 text-gray-600 italic">{adResult.description}</p>

            {/* תמונה */}
            <div className="mt-4">
              <img
                src={adResult.image_url}
                alt="Ad image"
                className="w-full h-auto rounded-lg"
              />
            </div>

            {/* קהל יעד */}
            <div className="mt-4">
              <h4 className="font-bold">קהל יעד</h4>
              <ul className="list-disc pl-4 text-gray-700">
                <li><strong>גילאים:</strong> {adResult.audience.age_range}</li>
                <li><strong>מגדר:</strong> {adResult.audience.gender}</li>
                <li><strong>תחומי עניין:</strong> {adResult.audience.interests.join(", ")}</li>
                <li><strong>שפה:</strong> {adResult.audience.language}</li>
              </ul>
            </div>

            {/* הנעה לפעולה */}
            <div className="mt-4">
              <p className="font-bold">הנעה לפעולה:</p>
              <button className="bg-blue-600 text-white py-2 px-6 rounded hover:bg-blue-700 transition">
                {adResult.call_to_action}
              </button>
            </div>

            {/* טון דיבור */}
            <div className="mt-4">
              <p><strong>טון דיבור:</strong> {adResult.tone}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
